const defaultCurrencyOptions: Intl.NumberFormatOptions = {
  style: "currency",
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
};

export function formatToBrl(value: number): string {
  return new Intl.NumberFormat("pt-BR", {
    ...defaultCurrencyOptions,
    currency: "BRL",
  }).format(value);
}

export function formatToOrdinaryNumber(value: number): string {
  return `${value}º`;
}

export function formatToUsd(value: number): string {
  return new Intl.NumberFormat("pt-BR", {
    ...defaultCurrencyOptions,
    currency: "USD",
  })
    .format(value)
    .replace(/US\$\s/g, "$ ");
}

export function randomNumberFromInterval(min: number, max: number, precision = 0): number {
  return parseFloat((Math.random() * (max - min) + min).toFixed(precision));
}

export function formatToPercentage(value: number): string {
  return `${(value * 100).toFixed(2)}%`;
}

export function isNumericRangeValid(value?: { from?: string | null; to?: string | null } | null): boolean {
  const from = value?.from?.toString().trim();
  const to = value?.to?.toString().trim();

  if (!from || !to) {
    return true;
  }

  if (!/^\d+$/.test(from) || !/^\d+$/.test(to)) {
    return true;
  }

  return Number(from) <= Number(to);
}

export const formatCentimetersToMeters = (num: number) => {
  const meters = Math.floor(num / 100);
  const centimeters = num % 100;

  return `${meters},${centimeters}m`;
};
